import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RamdomService {

  constructor() { }



  /**
   * 
   * @param min 
   * @param max 
   * @returns 
   */
  ramdomNumber(min: number, max: number): any {

    console.log("min", Math.random())
    let fee = Math.floor(Math.random() * (max - min)) + min;


    return `0.00` + fee;
  }
}
